document.querySelectorAll(".new-stores-tab-li").forEach(function(item){
  item.addEventListener("click", function(e){
    e.currentTarget.closest(".new-stores-wrapper").querySelectorAll(".new-stores-swiper, .new-stores-mobile-flex-wrapper").forEach(function(sw){
      sw.classList.remove("active");
    })
    e.currentTarget.closest(".new-stores-wrapper").querySelectorAll(".new-stores-tab-li").forEach(function(sw){
      sw.classList.remove("active");
    })
    let title = e.currentTarget.dataset.title;
    e.currentTarget.classList.add("active");
    e.currentTarget.closest(".new-stores-wrapper").querySelector(`.new-stores-swiper[data-title="${title}"]`).classList.add("active");
    e.currentTarget.closest(".new-stores-wrapper").querySelector(`.new-stores-mobile-flex-wrapper[data-title="${title}"]`).classList.add("active");
  })
})

document.querySelectorAll(".new-instagram-tab-li").forEach(function(item){
  item.addEventListener("click", function(e){
    e.currentTarget.closest(".new-instagram-wrapper").querySelectorAll(".new-instagram-swiper-wrapper").forEach(function(sw){
      sw.classList.remove("active");
    })
    e.currentTarget.closest(".new-instagram-wrapper").querySelectorAll(".new-instagram-tab-li").forEach(function(sw){
      sw.classList.remove("active");
    })
    let title = e.currentTarget.dataset.title;
    e.currentTarget.classList.add("active");
    e.currentTarget.closest(".new-instagram-wrapper").querySelector(`.new-instagram-swiper-wrapper[data-title="${title}"]`).classList.add("active");
    window.dispatchEvent(new Event('resize'));
  })
})

document.querySelectorAll(".f-mobile-nav__sub-link").forEach(function(item){
  item.addEventListener("click", function(e){
    if(e.currentTarget.getAttribute("href").indexOf("#") != -1){
      e.currentTarget.closest(".f-mobile-nav").querySelector(".f-drawer__close").dispatchEvent(new Event("click"));
    }
  })
})

function getCart() {
  return fetch("/cart.js").then(r => r.json());
}

function globalCartNoteController() {
  const allowedAttr = document.body.getAttribute("data-allowed-product-ids") || "";
  const allowedIds = allowedAttr.split(",").map(id => id.trim());

  getCart().then(cart => {
    const allowedInCart = cart.items.some(item =>
      allowedIds.includes(String(item.product_id))
    );
    if (allowedInCart) {
      const component = document.querySelector("cart-note-dropdowns");
      let noteText = "";
      if (component) {
        noteText = [...component.querySelectorAll("select")]
          .map(dd => dd.value ? `${dd.dataset.label}: ${dd.value}` : "")
          .filter(Boolean)
          .join(" | ");
        fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ note: noteText })
        });
      }
    } else {
      fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ note: "" })
      });
    }
  });
}

document.addEventListener("DOMContentLoaded", () => {
  globalCartNoteController();
  document.addEventListener("product-ajax:added", () => {
    setTimeout(globalCartNoteController, 500);
  });
  document.addEventListener("cart:updated", () => {
    setTimeout(globalCartNoteController, 500);
  });
});
class CartNoteDropdowns extends HTMLElement {
  connectedCallback() {
    this.dropdowns = this.querySelectorAll("select");
    this.dropdowns.forEach(dd => {
      dd.addEventListener("change", () => this.tryUpdate());
    });
    this.tryUpdate();
  }

  tryUpdate() {
    const allowedAttr = document.body.getAttribute("data-allowed-product-ids") || "";
    const allowedIds = allowedAttr.split(",").map(id => id.trim());
    getCart().then(cart => {
      const allowedInCart = cart.items.some(item =>
        allowedIds.includes(String(item.product_id))
      );
      if (allowedInCart) {
        this.updateNote();
      }
    });
  }

  updateNote() {
    const formatted = [...this.dropdowns]
      .map(dd => dd.value ? `${dd.dataset.label}: ${dd.value}` : "")
      .filter(Boolean)
      .join(" | ");
    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ note: formatted })
    });
  }
}

customElements.define("cart-note-dropdowns", CartNoteDropdowns);

window.FoxThemeEvents.subscribe(
  PUB_SUB_EVENTS.optionValueSelectionChange,
  ({ data }) => {
    const { event, target, selectedOptionValues } = data;
    let hasLineItems = false;
    document.querySelectorAll("product-info .variant-picker__input input[type=radio]:checked").forEach(function(opt){
      let val = opt.value.toLowerCase().trim();
      if(val == 'engraving - yes'){
        hasLineItems = true;
      }
    })
    if(hasLineItems){
      if(document.querySelectorAll("product-info product-form .new-pdp-line-item-field").length){
        document.querySelectorAll("product-info product-form .new-pdp-line-item-field").forEach(function(item){
          item.value = "";
          item.setAttribute("required", "");
        });
        document.querySelector(".new-pdp-line-items-wrapper").style.display = "block";
      }
    }
    else{
      if(document.querySelectorAll("product-info product-form .new-pdp-line-item-field").length){
        document.querySelectorAll("product-info product-form .new-pdp-line-item-field").forEach(function(item){
          item.value = "";
          item.removeAttribute("required");
        });
        document.querySelector(".new-pdp-line-items-wrapper").style.display = "none";
      }
    }
  }
);

function sortByLastName(container) {
  const cards = Array.from(container.children).filter(child => child.hasAttribute("data-name"));

  cards.sort((a, b) => {
    const getLastName = el => {
      const parts = el.getAttribute('data-name').split(' ');
      return parts[parts.length - 1].toLowerCase();
    };
    return getLastName(a).localeCompare(getLastName(b));
  });

  cards.forEach(card => container.appendChild(card));
  container.setAttribute("data-sort-lastname", "true");
}

function sortByDate(container, childSelector) {
  const cards = Array.from(container.querySelectorAll(childSelector));

  cards.sort((a, b) => {
    const dateA = new Date(a.dataset.date || 0);
    const dateB = new Date(b.dataset.date || 0);
    return dateB - dateA;
  });

  cards.forEach(card => container.appendChild(card));
  container.setAttribute("data-sort-date", "true");
}

// =============================
// SWIPER HELPER
// =============================

function initSwiper(swiperEl) {
  if (swiperEl.swiper) {
    swiperEl.swiper.destroy(true, true);
  }

  let shadowRoot = swiperEl.shadowRoot;
  // if (shadowRoot && !shadowRoot.querySelector('style[data-custom]')) {
  //   let style = document.createElement('style');
  //   style.setAttribute('data-custom', '');
  //   style.textContent = `
  //     .swiper-pagination-total {
  //       display: none;
  //     }
  //   `;
  //   shadowRoot.appendChild(style);
  // }

  Object.assign(swiperEl, {
    grid: { rows: 1, fill: 'row' },
    breakpoints: {
      0: {
        grid: { rows: parseFloat(swiperEl.getAttribute('grid-row-mobile')) || 1 }
      },
      768: {
        grid: { rows: parseFloat(swiperEl.getAttribute('grid-row')) || 1 }
      }
    }
  });

  swiperEl.initialize();
}

// =============================
// INIT
// =============================

function initAll() {
  // 1. sort by last name
  document.querySelectorAll('[data-sort-lastname]').forEach(container => {
    sortByLastName(container);
  });

  // 2. sort by date
  document.querySelectorAll('[data-sort-date]').forEach(container => {
    const childSelector = container.tagName.toLowerCase() === 'swiper-container'
      ? 'swiper-slide'
      : '.announcement_card';
    sortByDate(container, childSelector);
  });

  // 3. init swiper if the container tag is swiper-container
  document.querySelectorAll('[data-sort-lastname], [data-sort-date]').forEach(container => {
    if (container.tagName.toLowerCase() === 'swiper-container') {
      initSwiper(container);
    }
  });
}

document.addEventListener('DOMContentLoaded', initAll);
document.addEventListener('shopify:section:load', initAll);
document.addEventListener('shopify:section:reorder', initAll);

// --- Shopify Theme Editor: Scroll Swiper to selected block ---
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:block:select', function(e) {
    const blockId = e.detail && e.detail.blockId;
    if (!blockId) return;
    const slide = document.querySelector('.new-slider-swiper .block_' + blockId);
    if (!slide) return;
    const swiperContainer = slide.closest('swiper-container');
    if (swiperContainer && swiperContainer.swiper) {
      const slides = Array.from(swiperContainer.querySelectorAll('swiper-slide'));
      const index = slides.indexOf(slide);
      if (index !== -1) swiperContainer.swiper.slideTo(index);
    }
  });
}


class CustomAccordion extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.handleToggle();
    this.handleFilter();
  }

  handleToggle(e) {
    this.addEventListener("click", (event) => {
      if (!(this.querySelector(".collapsible_tab_header") instanceof HTMLElement) || !(this.querySelector(".collapsible_tab_content") instanceof HTMLElement)) return console.log("Malformed Accordion");
      if (!this.querySelector(".collapsible_tab_header").contains(event.target)) return;
      
      if (this.querySelector(".collapsible_tab_header").getAttribute("aria-expanded") === "true") {
        this.querySelector(".collapsible_tab_header").setAttribute("aria-expanded", "false");
      } else {
        this.querySelector(".collapsible_tab_header").setAttribute("aria-expanded", "true");
      }
    });
  }

  handleFilter() {
    const filterButtons = this.querySelectorAll("[data-filter-role]");
    if(filterButtons.length){
      filterButtons.forEach(button => {
        button.addEventListener("click", (e) => {
          filterButtons.forEach(btn => btn.classList.remove("active"));
          button.classList.add("active");
          const role = button.getAttribute("data-filter-role");
          const cards = button.closest(".card_container").querySelectorAll(".profile_card");
          cards.forEach(card => {
            const toggleElement = card.closest("swiper-slide") || card;
            if(role === "all" || card.dataset.role === role){
              toggleElement.style.display = "block";
            }
            else{
              toggleElement.style.display = "none";
            }
            e.target.closest(".card_container").querySelector("swiper-container")?.swiper.update();
          })
        });
      });
    }
  }
}
customElements.define("custom-accordion", CustomAccordion);

document.querySelectorAll(".new-faq-title").forEach(function(item){
  item.addEventListener("click", function(e){
    e.currentTarget.classList.toggle("active");
  })
})